class Environment {

  private backendEndpoint: string;
  private frontendEndpoint: string;
  private developersName: string;
  private environment: string;
  private buildDate: number;
  private renderer: string;
  private clientId: string;
  private rollbarApiKey: string;
  private googlePlacesApiKey: string;
  // private helpCrunchOrganizationSecret: string;

  constructor() {
    this.frontendEndpoint = document.location.origin;
    
    if (typeof process.env.ENVIRONMENT !== "undefined") {
      this.backendEndpoint = process.env.BACKEND_ENDPOINT;
      this.developersName = process.env.DEVELOPERS_NAME;
      this.environment = process.env.ENVIRONMENT;
      this.clientId =  process.env.CLIENT_ID;
      this.buildDate = parseInt(process.env.BUILD_DATE, 10);
      this.renderer = "webpack";
      this.rollbarApiKey = process.env.ROLLBAR_API_KEY;
      this.googlePlacesApiKey = process.env.GOOGLE_PLACES_API_KEY;
      // this.helpCrunchOrganizationSecret = process.env.HELPCRUNCH_ORGANIZATION_SECRET;
    } else if (typeof (window as any).ENVIRONMENT !== "undefined") {
      this.backendEndpoint = (window as any).BACKEND_ENDPOINT;
      this.developersName = (window as any).DEVELOPERS_NAME;
      this.clientId = (window as any).CLIENT_ID;
      this.environment = (window as any).ENVIRONMENT;
      this.buildDate = parseInt((window as any).BUILD_DATE, 10);
      this.renderer = "node";
      this.rollbarApiKey = (window as any).ROLLBAR_API_KEY;
      this.googlePlacesApiKey = (window as any).GOOGLE_PLACES_API_KEY;
      // this.helpCrunchOrganizationSecret = (window as any).HELPCRUNCH_ORGANIZATION_SECRET;
    } else {
      throw new Error(`Environment could not read variables.`);
    }
  }

  public get(): any {
    return {
      backendEndpoint: this.backendEndpoint,
      developersName: this.developersName,
      environment: this.environment,
      buildDate: this.buildDate,
      renderer: this.renderer,
      clientId: this.clientId,
      rollbarApiKey: this.rollbarApiKey,
      googlePlacesApiKey: this.googlePlacesApiKey,
      // helpCrunchOrganizationSecret: this.helpCrunchOrganizationSecret
    };
  }

  public isRenderedByNode(): boolean {
    return this.isRenderedByWebpack() === false;
  }

  public isRenderedByWebpack(): boolean {
    return this.renderer === "webpack";
  }

  public getBuildDate(): number {
    return this.buildDate;
  }

  public getBackendEndpoint(): string {
    return this.backendEndpoint;
  }

  public getFrontendEndpoint(): string {
    return this.frontendEndpoint;
  }

  public isDevelopment(): boolean {
    return this.environment === "development";
  }

  public isStaging(): boolean {
    return this.environment === "staging";
  }

  public isProduction(): boolean {
    return this.environment === "production";
  }

  public belongsTo(developersName): boolean {
    return this.developersName === developersName;
  }
}

export default new Environment();
